import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersistence from 'vuex-persist'
import createLogger from 'vuex/dist/logger';

import {
  CANVAS_CANONICAL,
  CANVAS_MAIN,
  CANVAS_SECOND,
} from '@/constants';

// Modules
import application from './modules/application';
import formations from './modules/formations';
import jerseys from './modules/jerseys';
import user from './modules/user';
import notification from './modules/notification';
import projects from './modules/projects';
import project from './modules/project';
import keys from './modules/keys';
import venues from './modules/venues';
import teams from './modules/teams';
import players from './modules/players';
import outfits from './modules/outfits';
import files from './modules/files';
import usage from './modules/usage';
import fsm from './modules/fsm';
import tracksMapping from './modules/tracks_mapping';
import videoPlayer from './modules/videoPlayer';
import stats from './modules/stats';
import users from './modules/users';

Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

const vuexLocal = new VuexPersistence({
  reducer: state => ({
    project: {
      [CANVAS_CANONICAL]: {
        visible: state.project[CANVAS_CANONICAL].visible,
      },
      [CANVAS_MAIN]: {
        visible: state.project[CANVAS_MAIN].visible,
      },
      [CANVAS_SECOND]: {
        visible: state.project[CANVAS_SECOND].visible,
      },
      currentFrame: state.project.currentFrame,
      events: {
        filters: state.project.events.filters,
      },
      filters: state.project.filters,
    },
    tracksMapping: {
      filters: state.tracksMapping.filters
    },
  }),
  storage: window.localStorage,
});

const plugins = [vuexLocal.plugin];
if (debug) {
  plugins.push(createLogger());
}

export default new Vuex.Store({
  /**
   * Assign the modules to the store.
   */
  modules: {
    application,
    formations,
    jerseys,
    user,
    notification,
    projects,
    project,
    keys,
    venues,
    teams,
    players,
    outfits,
    files,
    usage,
    fsm,
    tracksMapping,
    videoPlayer,
    stats,
    users,
  },

  /**
   * If strict mode should be enabled.
   */
  strict: debug,

  /**
   * Plugins used in the store.
   */
  plugins,
});
